var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('com-search',{attrs:{"columns":_vm.searchColumn},on:{"search":_vm.search}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }